import { FormConfig } from '../models/dynamic.model';

export const mapKeyToLabels: Record<string, string> = {
  billNumber: 'Bill Number',
  carrier: 'Carrier',
  countryOfOrigin: 'Country Of Origin',
  currency: 'Currency',
  date: 'Date',
  finalDestination: 'Final Destination',
  invoice: 'Invoice',
  notes: 'Notes',
  poNumber: 'PO Number',
  contents: 'Contents',
  createdDateAndTime: 'Created',
  description: 'Description',
  hts: 'HTS',
  pieces: 'Pieces',
  reference: 'Reference',
  service: 'Service',
  value: 'Value($)',
  weight: 'Weight',
  righToInspect: 'Render to Inspect',
  limitationToLiability: 'Limitation of Liability',
};

export const commercialInvoiceTotalGridColumnConfig = [
  { key: 'description', label: 'Description' },
  { key: 'htsCode', label: 'HTS Code' },
  { key: 'quantity', label: 'Quantity' },
  { key: 'weight', label: 'Total Weight' },
  { key: 'value', label: 'Total Value' },
  { key: 'countryCode', label: 'Country of Origin' },
  { key: 'itemNumber', label: 'Item Number' },
];

export const profileInfoFormFieldConfig: FormConfig = {
  fields: [
    {
      id: 'fullName',
      type: 'input',
      required: true,
      requiredError: 'Full Name is required',
      label: 'Full Name',
    },
    {
      id: 'email',
      type: 'input',
      required: true,
      label: 'Username(Email)',
    },
    {
      id: 'measurementOptions',
      type: 'select',
      label: 'Measurement Options',
      required: true,
      requiredError: 'Measurement Options is required',
    },
  ],
};
